import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-agency-two-services',
  templateUrl: './agency-two-services.component.html',
  styleUrls: ['./agency-two-services.component.scss']
})
export class AgencyTwoServicesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
